<script setup lang="ts">
defineProps<{
  title?: string
  text?: string
  buttonText?: string
}>()
function reload() {
  return location.reload()
}
const appConfig = useAppConfig()
const locale = appConfig.locale.code
</script>

<template>
  <BasePopup :model-value="true" :title="text || locale === 'cs' ? 'Došlo k chybě...' : 'Došlo k chybe...'" z-index="16">
    {{ text || locale === 'cs' ? 'Zkuste to prosím znovu nebo zkuste obnovit stránku.' : 'Skúste to prosím znova alebo skúste obnoviť stránku.' }}
    <template #footer>
      <BaseButton class="w-full " @click="reload">
        {{ buttonText || locale === 'cs' ? 'Obnovit stránku' : ' Obnoviť stránku' }}
      </BaseButton>
    </template>
  </BasePopup>
</template>
